<template>
  <customModal
    :containermd="true"
    :footerShow="false"
    @closeModal="closeCraIssue"
  >
    <template #title>
      <h4 class="my-0">
        {{
          isEditing
            ? $t("navigations.update issue")
            : $t("navigations.raise issue")
        }}
      </h4>
    </template>

    <template #body>
      <div class="ibox-content-edit">
        <div class="ibox-body">
          <div class="form-group row">
            <div class="col-md-6">
              <label for="subject">
                {{ $t("navigations.subject") }}
              </label>
              <input
                v-model="subject"
                id="subject"
                type="text"
                class="form-control"
                placeholder="Enter subject"
              />
            </div>

            <div class="col-md-6">
              <label for="visitType">
                {{ $t("navigations.visit type") }}
              </label>
              <select v-model="visitType" id="visitType" class="form-control">
              <option value="">{{ $t("navigations.select visit type") }}</option>
                <option
                  v-for="visit in visitTypes"
                  :key="visit.id || visit.visitTypeId"
                  :value="visit.name || visit.type"
                >
                  {{ visit.name || visit.type }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-4">
              <label for="severity">
                {{ $t("navigations.severity") }}
              </label>
              <select v-model="severity" id="severity" class="form-control">
                <option value="">
                  {{ $t("navigations.select severity") }}
                </option>
                <option value="Minor">Minor</option>
                <option value="Major">Major</option>
                <option value="Critical">Critical</option>
              </select>
            </div>

            <div class="col-md-4">
              <label for="priority">
                {{ $t("navigations.priority") }}
              </label>
              <select v-model="priority" id="priority" class="form-control">
                <option value="">
                  {{ $t("navigations.select priority") }}
                </option>
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
              </select>
            </div>

            <div class="col-md-4">
              <label for="status">
                {{ $t("navigations.status") }}
              </label>
              <select v-model="status" id="status" class="form-control">
                <option value="">
                  {{ $t("navigations.select status") }}
                </option>
                <option value="Open">Open</option>
                <option value="In Progress">In Progress</option>
                <option value="Closed">Closed</option>
              </select>
            </div>

            <!-- <div class="col-md-3">
                        <label for="linkedVisitId">
                            {{ $t("navigations.linked visit") }}
                        </label>
                        <input
                            v-model="linkedVisitId"
                            id="linkedVisitId"
                            type="text"
                            class="form-control"
                            placeholder="Enter visit ID"
                        />
                    </div> -->
          </div>

          <div class="form-group">
            <label for="summary">{{ $t("navigations.summary") }}</label>
            <textarea
              v-model="summary"
              id="summary"
              class="form-control"
              placeholder="Enter summary"
            ></textarea>
          </div>
               <div v-if="!isEditing">

              <hr/>

              <div class="form-group row">

                <!-- ROLE -->
                <div class="col-md-6">
                  <label>{{ $t("navigations.choose role") }}</label>
                  <Multiselect
                    v-model="selectedRole"
                    :options="roleList"
                    label="roleName"
                    trackBy="roleID"
                    valueProp="roleID"
                    placeholder="Select Role"
                    class="multiselect-theme mt-1"
                    @change="onRoleChange"
                  />
                </div>

                <!-- Reporter Email -->
                <div class="col-md-6">
                  <label>{{ $t("navigations.recipient email") }}</label>
                  <Multiselect
                    v-model="reporterEmail"
                    :options="userList"
                    label="email"
                    trackBy="userID"
                    valueProp="email"
                    placeholder="Select Assigner"
                    class="multiselect-theme mt-1"
                    :disabled="!selectedRole"
                  />
                </div>

              </div>

              <hr/>

              </div>


         <div class="form-group row">

  <!-- Tags -->
       <div :class="isEditing ? 'col-md-4' : 'col-md-6'">
    <label for="tags">
      {{ $t("navigations.tags") }}
    </label>
    <Multiselect
      id="tags"
      v-model="tags"
      mode="multiple"
      placeholder="Select or add tags"
      :options="['MVR', 'SV']"
      :taggable="true"
      :searchable="true"
      class="multiselect-theme"
    />
      </div>

        <!-- Due At -->
        <div :class="isEditing ? 'col-md-4' : 'col-md-6'">
          <label for="dueAt">
            {{ $t("navigations.due at") }}
          </label>
          <input
            v-model="dueAt"
            id="dueAt"
            type="date"
            class="form-control"
          />
        </div>

        <!-- Resolved At -->
        <div class="col-md-4" v-if="isEditing">
          <label for="resolvedAt">
            {{ $t("navigations.resolved at") }}
          </label>
          <input
            v-model="resolvedAt"
            id="resolvedAt"
            type="date"
            class="form-control"
          />
        </div>

      </div>

          <div class="form-group row mt-2">
            <div class="col-md-6">
              <label>{{ $t("navigations.title") }}</label>
              <input
                v-model="references[0].label"
                type="text"
                class="form-control"
                placeholder="Enter reference label"
              />
            </div>

            <div class="col-md-6">
              <label>{{ $t("navigations.upload file") }}</label>
              <input
                type="file"
                accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf"
                @change="handleFileUpload"
                class="form-control"
              />
            </div>
          </div>

          <div class="text-end mt-3">
            <button
              class="cancel_btn py-1 px-3 mx-3"
              type="button"
              @click.prevent="closeValidationRule()"
            >
              {{ $t("navigations.cancel") }}
            </button>
            <button
              type="button"
              class="save_btn py-1 px-4 position-relative"
              @click="saveValidationRule"
            >
              <div
                class="toc-loader position-absolute"
                :class="{
                  'opacity-0': !loadingValidationRule,
                  'opacity-1': loadingValidationRule,
                }"
              >
                <img
                  src="../../assets/img/loading.gif"
                  width="15"
                  class="loading-btn-img"
                  alt="Waiting for login"
                />
              </div>
              <p
                class="mb-0"
                :class="{
                  'opacity-1': !loadingValidationRule,
                  'opacity-0': loadingValidationRule,
                }"
              >
                {{
                  isEditing ? $t("navigations.update") : $t("navigations.save")
                }}
              </p>
            </button>
          </div>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script src="./createCraIssue.js"></script>

<style scoped>
.multiselect-theme {
  --ms-radius: 0;
  --ms-py: 0.4rem;
  --ms-option-font-size: 0.8rem;
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}

.errorClass {
  color: red;
  font-size: 0.8rem;
}

.wrapper-content {
  padding: 0.5rem;
}

.ibox-content {
  border: none;
  padding: 0.5rem 0;
}

.save_btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
}

.max-height-400,
.height-400 {
  max-height: 400px;
  overflow-y: scroll;
}



</style>
